import React, { useState, useReducer, useRef, useEffect } from 'react';
import { motion } from "framer-motion";
import { CButton, CPortal } from '..';

import './style.scss';

const CDropDown = ({children, isClosed = false, trigger, maxWidth = 300, className = ''}) => {
    const [open, setOpen] = useState(false);
    const dropDownRef = useRef(null); 
    const dropDownTriggerRef = useRef(null);
    const dropDownContentRef = useRef(null);
    const [contentMeta, updateContentMeta] = useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            top: 0,
            left: 0,
            right: 0,
        },
    );

    useEffect(() => {
        isClosed && setOpen(false);
    }, [isClosed]);

    useEffect(() => {
        handleUpdatePosition();

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
            window.addEventListener("scroll", handleWindowScroll);

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
                window.removeEventListener("scroll", handleWindowScroll);
            };
        }
    }, [open]);

    function handleUpdatePosition() {
        const pageContent = document.querySelector('.page-overlay');
        if (!dropDownContentRef.current || !pageContent) return;

        const contentRect = dropDownContentRef.current.getBoundingClientRect();
        const style = window.getComputedStyle(pageContent);
        const sidePadding = +style.getPropertyValue('padding').replace(/\D+/g, '');

        const pageContentWidth = window.innerWidth - (sidePadding * 2) - 10;

        if (maxWidth >= window.innerWidth || window.innerWidth < 600) {

            updateContentMeta({
                top: contentMeta.top,
                left: contentRect.width < contentMeta.left ? contentMeta.left - contentRect.width : (sidePadding + 5),
                right: 5,
                width: pageContentWidth,
            });

        }
    }

    function handleWindowScroll() {
        const {top, height} = dropDownRef.current.getBoundingClientRect();
        updateContentMeta({
            top: top + height + 10,
        });
    }

    function handleClickOutside(event) {
        if (
                (dropDownRef.current && !dropDownRef.current.contains(event.target)) &&
                (dropDownContentRef.current && !dropDownContentRef.current.contains(event.target))
            ) {
            setOpen(!open);
        }
    }

    function toggleDropDownContent(e) {
        e.preventDefault();

        setOpen(!open);

        const triggerCoords = dropDownTriggerRef.current.getBoundingClientRect();
        const left = triggerCoords.left + triggerCoords.width;
        const right = window.innerWidth - triggerCoords.right;

        updateContentMeta({
            top: triggerCoords.top + triggerCoords.height + 10,
            left: left > right ? 'unset' : left,
            right: left > right ? right : 'unset',
        });
    }

    return (
        <div
            ref={dropDownRef}
            className="c-dropdown"
        >
            <div className="c-dropdown-header">
                <div
                    ref={dropDownTriggerRef}
                    className={`c-dropdown-trigger ${open ? 'c-dropdown-trigger--open' : ''}`}
                    onClick={toggleDropDownContent}
                >
                    {trigger}
                </div>
            </div>
            <CPortal>
                {
                    open &&
                    (<motion.div
                        key="dropdown"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{duration: 0.3, ease: 'easeInOut'}}
                        ref={dropDownContentRef}
                        className={`c-dropdown-content scrollable background-blur ${className}`}
                        style={{
                            ...contentMeta,
                            maxWidth: window.innerWidth < 600 ? 'unset' : maxWidth || window.innerWidth
                        }}
                    >
                        {children}
                    </motion.div>)
                }
            </CPortal>
        </div>
    )
};

export default CDropDown;
